<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: number | string;
    color?: string;
    weight?: "regular" | "fill";
  }>(),
  {
    size: 24,
    color: "currentColor",
    weight: "regular",
  }
);
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="color"
    v-bind="$attrs"
  >
    <template v-if="weight === 'regular'">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.25714 14.2285C6.25714 13.6605 6.71765 13.2 7.28571 13.2H16.7143C17.2823 13.2 17.7429 13.6605 17.7429 14.2285C17.7429 14.7966 17.2823 15.2571 16.7143 15.2571H7.28571C6.71765 15.2571 6.25714 14.7966 6.25714 14.2285ZM7.28571 16.9714C6.71765 16.9714 6.25714 17.4319 6.25714 18C6.25714 18.5681 6.71765 19.0286 7.28571 19.0286H12C12.5681 19.0286 13.0286 18.5681 13.0286 18C13.0286 17.4319 12.5681 16.9714 12 16.9714H7.28571ZM6.42857 4.97142C6.42857 4.59271 6.73557 4.28571 7.11428 4.28571H16.8857C17.2644 4.28571 17.5714 4.59271 17.5714 4.97142V10.4571C17.5714 10.8358 17.2644 11.1428 16.8857 11.1428H13.4486L8.9331 6.86252C8.62411 6.56963 8.12314 6.56963 7.81415 6.86252L6.42857 8.17594V4.97142ZM14.3077 5.14285C13.2153 5.14285 12.3297 6.02933 12.3297 7.12285C12.3297 8.21637 13.2153 9.10285 14.3077 9.10285C15.4001 9.10285 16.2857 8.21637 16.2857 7.12285C16.2857 6.02933 15.4001 5.14285 14.3077 5.14285Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.5 1C4.11929 1 3 2.11929 3 3.5V20.5C3 21.8807 4.11929 23 5.5 23H18.5C19.8807 23 21 21.8807 21 20.5V3.5C21 2.11929 19.8807 1 18.5 1H5.5ZM5 3.5C5 3.22386 5.22386 3 5.5 3H18.5C18.7761 3 19 3.22386 19 3.5V20.5C19 20.7761 18.7761 21 18.5 21H5.5C5.22386 21 5 20.7761 5 20.5V3.5Z"
      />
    </template>
    <template v-else-if="weight === 'fill'">
      <path
        d="M14.3077 5.14287C13.2153 5.14287 12.3297 6.02934 12.3297 7.12287C12.3297 8.21639 13.2153 9.10287 14.3077 9.10287C15.4002 9.10287 16.2858 8.21639 16.2858 7.12287C16.2858 6.02934 15.4002 5.14287 14.3077 5.14287Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.00003 1.99994C4.44775 1.99994 4.00003 2.44766 4.00003 2.99994V20.9999C4.00003 21.5522 4.44775 21.9999 5.00003 21.9999H19C19.5523 21.9999 20 21.5522 20 20.9999V2.99994C20 2.44766 19.5523 1.99994 19 1.99994H5.00003ZM7.28573 13.2C6.71766 13.2 6.25716 13.6605 6.25716 14.2286C6.25716 14.7966 6.71766 15.2571 7.28573 15.2571H16.7143C17.2824 15.2571 17.7429 14.7966 17.7429 14.2286C17.7429 13.6605 17.2824 13.2 16.7143 13.2H7.28573ZM6.25716 18C6.25716 17.4319 6.71766 16.9714 7.28573 16.9714H12C12.5681 16.9714 13.0286 17.4319 13.0286 18C13.0286 18.5681 12.5681 19.0286 12 19.0286H7.28573C6.71766 19.0286 6.25716 18.5681 6.25716 18ZM7.1143 4.28572C6.73559 4.28572 6.42858 4.59273 6.42858 4.97144V8.17596L7.81417 6.86253C8.12316 6.56964 8.62412 6.56964 8.93311 6.86253L13.4486 11.1429H16.8857C17.2644 11.1429 17.5714 10.8359 17.5714 10.4572V4.97144C17.5714 4.59273 17.2644 4.28572 16.8857 4.28572H7.1143Z"
      />
    </template>
  </svg>
</template>
